export default "__VITE_ASSET__Bt7ATSKz__"